module.exports = __webpack_public_path__ + "img/2015-4.05831ed9.jpg";